
/**
 * Loads and initializes Stripe.js
 */

import { STRIPE_PUBLIC_KEY } from '../../services/stripe/config';

let stripePromise: Promise<any> | null = null;
let stripeInstance: any | null = null;

/**
 * Loads the Stripe.js script
 */
export const loadStripeJs = async (): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      reject(new Error('Stripe.js can only be loaded in browser environment'));
      return;
    }

    if (window.Stripe) {
      resolve(true);
      return;
    }

    console.log('Loading Stripe.js script...');
    
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/';
    script.async = true;
    script.onload = () => {
      console.log('Stripe.js script loaded successfully');
      resolve(true);
    };
    script.onerror = () => {
      console.error('Failed to load Stripe.js script');
      reject(new Error('Failed to load Stripe.js script'));
    };

    document.head.appendChild(script);
  });
};

/**
 * Initializes Stripe with the publishable key
 */
export const initializeStripe = async (): Promise<any> => {
  try {
    console.log('Initializing Stripe with key:', STRIPE_PUBLIC_KEY);
    
    // Make sure Stripe.js is loaded
    if (!window.Stripe) {
      await loadStripeJs();
    }

    if (!stripeInstance) {
      stripeInstance = window.Stripe(STRIPE_PUBLIC_KEY);
      console.log('Stripe initialized successfully');
    }
    
    return stripeInstance;
  } catch (error) {
    console.error('Error initializing Stripe:', error);
    throw error;
  }
};

/**
 * Gets the Stripe instance or initializes it
 */
export const getStripeInstance = async (): Promise<any> => {
  if (!stripeInstance) {
    return initializeStripe();
  }
  return stripeInstance;
};

// No need to declare the global Window interface here as it's now in global.d.ts
